export const MAPSDATA = [
    {
        "uuid": "7eaecc1b-4337-bbf6-6ab9-04b8f06b3319",
        "displayName": "Ascent",
        "coordinates": "45°26'BF'N,12°20'Q'E",
        "displayIcon": "img/maps/Ascent-display.png",
        "listViewIcon": "img/maps/Ascent-list.png",
    },
    {
        "uuid": "d960549e-485c-e861-8d71-aa9d1aed12a2",
        "displayName": "Split",
        "coordinates": "35°41'CD'N,139°41'WX'E",
        "displayIcon": "img/maps/Split-display.png",
        "listViewIcon": "img/maps/Split-list.png",
    },
    {
        "uuid": "2c9d57ec-4431-9c5e-2939-8f9ef6dd5cba",
        "displayName": "Bind",
        "coordinates": "34°2'A'N,6°51'Z'W",
        "displayIcon": "img/maps/Bind-display.png",
        "listViewIcon": "img/maps/Bind-list.png",
    },
    {
        "uuid": "2fb9a4fd-47b8-4e7d-a969-74b4046ebd53",
        "displayName": "Breeze",
        "coordinates": null,
        "displayIcon": "img/maps/Breeze-display.png",
        "listViewIcon": "img/maps/Breeze-list.png",
    },
    {
        "uuid": "e2ad5c54-4114-a870-9641-8ea21279579a",
        "displayName": "Icebox",
        "coordinates": "76°44' A\"N 149°30' Z\"E",
        "displayIcon": "img/maps/Icebox-display.png",
        "listViewIcon": "img/maps/Icebox-list.png",
    },
    {
        "uuid": "ee613ee9-28b7-4beb-9666-08db13bb2244",
        "displayName": "The Range",
        "coordinates": "45°26'FF'N,12°20'Q'E",
        "displayIcon": "img/maps/Range-display.png",
        "listViewIcon": "img/maps/Range-list.png",
    },
    {
        "uuid": "2bee0dc9-4ffe-519b-1cbd-7fbe763a6047",
        "displayName": "Haven",
        "coordinates": "27°28'A'N,89°38'WZ'E",
        "displayIcon": "img/maps/Haven-display.png",
        "listViewIcon": "img/maps/Haven-list.png",
    }
]